{
  "tabs": {
    "chat": "Chat",
    "reminders": "Reminders",
    "calendar": "Calendar",
    "settings": "Settings"
  },
  "common": {
    "cancel": "Elghe",
    "save": "E7faz",
    "confirm": "Akkid",
    "delete": "E7zef",
    "back": "Erja3",
    "close": "Sakker",
    "edit": "Ghayyir",
    "search": "Dawwer",
    "all": "Kel shi",
    "loading": "3am ye7mil...",
    "error": "Sar shi ghalat",
    "notFound": "Mish mawjoud",
    "tryAgain": "Jarreb kamen",
    "retry": "Jarreb kamen",
    "undo": "Undo",
    "pullToRefresh": "Shob la te7addis",
    "justNow": "halla2"
  },
  "auth": {
    "welcome": "Ahla b FishMemory",
    "tagline": "Mosa3dak lal reminders, halla2 b jebtak.",
    "subtitle": "Mosa3dak lal reminders, halla2 b jebtak.",
    "phoneLabel": "Ra2mak 3a WhatsApp",
    "phoneHint": "Rah neb3at code ta7a22a2 3a WhatsApp",
    "invalidPhone": "Ktob ra2m sa7i7",
    "continue": "Kammel",
    "enterPhone": "Ktob ra2m WhatsApp taba3ak",
    "phonePlaceholder": "Ra2em telephone",
    "sendCode": "B3at el code",
    "verifyTitle": "Ta7a22a2 men ra2mak",
    "otpSentTo": "B3atna code 6 ar2am la {{phone}} 3a WhatsApp",
    "enterFullCode": "Ktob kel el 6 ar2am",
    "invalidOtp": "El code ghalat. Jarreb kamen.",
    "otpFailed": "Ma zabet neb3at el code. Jarreb kamen.",
    "otpResent": "Nb3at el code kamen",
    "resendIn": "B3at kamen ba3d {{seconds}} tenye",
    "resendCode": "B3at kamen",
    "enterOtp": "Ktob el code yalli b3atnelak 3a WhatsApp",
    "verify": "Ta7a22a2",
    "resend": "B3at kamen",
    "wrongNumber": "Ra2m ghalat?",
    "backToPhone": "Erja3 3al ra2m",
    "editPhone": "Ghayyir el ra2m",
    "error": "Ghalat",
    "setupTitle": "Yalla nkammel el setup",
    "setupSubtitle": "Fik tghayyir haydol ba3den men Settings",
    "namePlaceholder": "Esmak",
    "letsGo": "Kammel el setup",
    "skipForNow": "Khalliha la ba3den"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Ktob message...",
    "inputPlaceholder": "Ktob message...",
    "typing": "FishMemory 3amyet ktob...",
    "online": "Online",
    "connecting": "3am yitwassal...",
    "reconnecting": "3am y3id yitwassal...",
    "offline": "Offline",
    "empty": "Ballesh 7aki",
    "emptyHint": "A3mel reminder, chouf jadwalak, aw etlob mousa3ade.",
    "emptyAction": "B3at reminder tajribi",
    "actions": "Chat actions",
    "keep": "Khalli el messages",
    "clearTitle": "Imsa7 el chat",
    "clearConfirm": "Baddak temsa7 kel el messages men hal device? ma fina nerja3 warah.",
    "clear": "Imsa7 el chat",
    "optionSelected": "Ikhtarat: {{label}}",
    "sendingSelection": "3am yitba3at...",
    "connectionLost": "3am yerja3 yetwassal..."
  },
  "reminders": {
    "title": "Reminders Taba3e",
    "active": "Active",
    "today": "Lyom",
    "thisWeek": "Hal jom3a",
    "history": "Tarikh",
    "items": "items",
    "emptyTitle": "Ma fi reminders ba3d",
    "emptySubtitle": "A3mel reminder men el chat w rah ybayyen ┘ç┘ê┘å.",
    "emptyAction": "Fout 3al chat",
    "filterActive": "Active",
    "filterToday": "Lyom",
    "filterWeek": "Hal jom3a",
    "filterHistory": "Tarikh",
    "emptyState": "Ma fi reminders ba3d. Yalla ballesh e7ke!",
    "swipeDone": "Tamem",
    "swipeSnooze": "Akher",
    "swipeDelete": "E7zef",
    "search": "Dawwer 3a reminder...",
    "upcoming": "Ejye",
    "completed": "Khlson",
    "overdue": "Mta2akhkhar",
    "tomorrow": "Bukra",
    "synced": "Synced {{value}}",
    "swipeHint": "Shob 3al reminder la mazid men el actions",
    "showAllCount": "Farje kellon ({{count}})",
    "showFewer": "Farje a2all",
    "noResults": "Ma fi reminders btet2eblak",
    "noResultsHint": "Jarreb kelme tenye aw emsa7 el search",
    "deleteAllFailed": "Ma zabet e7zef kel el reminders"
  },
  "calendar": {
    "title": "Calendar",
    "today": "Lyom",
    "tomorrow": "Bokra",
    "completed": "khlas",
    "noEvents": "Ma fi shi",
    "noEventsSubtitle": "Ikhtar nhar la tchouf reminders w events.",
    "googleEvent": "Google Calendar",
    "legendActive": "Active",
    "legendRecurring": "Byetraddad",
    "legendDone": "Tamem",
    "legendGoogle": "Google",
    "previousMonth": "El shahr li abl",
    "nextMonth": "El shahr li ba3do",
    "previousYear": "El sene li abel",
    "nextYear": "El sene li ba3da",
    "goToToday": "Rou7 3a lyom",
    "all": "Kelon",
    "active": "Active",
    "done": "Tamem",
    "paused": "Mwa22af"
  },
  "settings": {
    "title": "Settings",
    "profile": "Profile",
    "name": "Display Name",
    "enterName": "Ktob esmak",
    "language": "Logha",
    "uiLanguage": "Loghet el app",
    "uiLanguageHelp": "Bteghayyer ┘ê╪º╪¼┘ç╪⌐ el app w calendar labels w direction 3a hal device bas.",
    "serverLanguage": "Loghet el chat",
    "serverLanguageHelp": "Bteghayyer loghet raddet el server w reminder messages 3a 7sebak.",
    "timezone": "Timezone",
    "currentTimezone": "El timezone el halla2",
    "timezoneHelp": "Aw2at el reminders rah tin3arad 7asab hayda el timezone.",
    "timezonePlaceholder": "Asia/Beirut",
    "timezoneSave": "E7faz el timezone",
    "timezoneSaved": "Tghayyar el timezone",
    "detect": "Kshif",
    "detectFailed": "Ma fina nkshif el timezone",
    "autoDetect": "Kshif men el GPS",
    "notifications": "Esh3arat",
    "notificationsHelp": "Follow-up reminders ╪¿┘è╪¬╪¡┘â┘æ┘à┘ê╪º bel alerts l m┘â╪▒╪▒╪⌐ ba3d ma yitba3at el reminder. Salahiyet el notifications taba3 el device btedal men settings taba3 el telephone.",
    "pushEnabled": "Push Notifications",
    "autoDoneOnFire": "Auto-done lamma yit2alle2",
    "autoDoneOnFireDesc": "Eza matfe, el reminders byib2o active la2 ma ta3mol done.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Mawsool",
    "googleDisconnected": "Mish mawsool",
    "googleConnectedHelp": "Fina nsync reminders jdod ╪¬┘ä┘é╪º╪ª┘è╪º┘ï.",
    "googleDisconnectedHelp": "Wssel Google Calendar la ydal el reminders w events ma3 ba3d.",
    "googleConnectFailed": "Ma zabet el rabet ma3 Google Calendar",
    "connected": "Mawsool",
    "disconnected": "Mish mawsool",
    "connect": "Wssel",
    "disconnect": "Fsel",
    "autoSync": "Autosync lal reminders jdod",
    "autosync": "Autosync",
    "subscription": "Ishtirak",
    "trialUsed": "Trial: {{used}}/{{total}}",
    "trialStatus": "Fi trial ba3ed",
    "activeStatus": "Ishtirak active",
    "expiredStatus": "El ishtirak entaha",
    "unsubscribedStatus": "Mish mishterik",
    "about": "3an",
    "version": "Version",
    "logout": "Tla3",
    "logoutTitle": "Tla3",
    "logoutConfirm": "Akeed baddak tetla3?",
    "noName": "Ma fi esem",
    "serverConnection": "Server connection",
    "serverUrl": "Server URL",
    "serverEdit": "Ghayyir",
    "saveReconnect": "E7faz w 3id el rabet",
    "resetDefault": "Rajja3 default",
    "invalidServerUrlTitle": "Server URL mish sa7i7",
    "invalidServerUrlMessage": "Ktob http aw https sa7i7, metel https://example.com",
    "uiLanguageChangeFailed": "Ma zabet tghayyir loghet el app. Jarreb kamen.",
    "serverLanguageChangeFailed": "Ma zabet tghayyir loghet el chat. Jarreb kamen.",
    "timezoneChangeFailed": "Ma zabet tghayyir el timezone. Jarreb kamen.",
    "autoSyncChangeFailed": "Ma zabet tghayyir el autosync. Jarreb kamen.",
    "nameChangeFailed": "Ma zabet tghayyir el esem. Jarreb kamen.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Reminder details",
    "editTime": "Ghayyir el wa2et",
    "rename": "Ghayyir el esem",
    "snooze": "Akher",
    "snooze15": "Akher 15 d2i2a",
    "pause": "Wa22ef",
    "pauseReminder": "Wa22ef el reminder",
    "resume": "Kammel",
    "resumeReminder": "Kammel el reminder",
    "skip": "Skippeh",
    "skipOccurrence": "Skip hayde el marra",
    "syncGoogle": "Sync 3a Google",
    "delete": "E7zef",
    "deleteTitle": "E7zef el reminder",
    "deleteConfirm": "Hal reminder rah yen7azaf nihaiyyan.",
    "deleteRecurringTitle": "E7zef reminder byetraddad",
    "deleteRecurringMessage": "Baddak tskip hayde el marra aw te7zef kel el series?",
    "deleteThisOccurrence": "Skip hayde el marra",
    "deleteEntireSeries": "E7zef kel el series",
    "done": "Tamem",
    "markDone": "7ott tamem",
    "undo": "Rajja3 active",
    "undoPrompt": "Iza badak yirja3 active, fik ╪¬╪▒╪¼╪╣┘ê hala2.",
    "recurring": "Byetraddad",
    "nextRun": "El marra el jeye",
    "oneTime": "Marra wa7de",
    "pending": "3am yente2er",
    "sent": "Nba3at",
    "paused": "Mwa22af",
    "active": "Active",
    "snoozed": "M2ajjal",
    "localTime": "Mabayan 7asab wa2et el device",
    "recurrence": "El takrar",
    "created": "Tkhala2",
    "tags": "Tags",
    "fireCount": "Addad el marat",
    "actions": "Actions",
    "none": "Ma fi",
    "snoozeFailed": "Ma zabet n2ajjel el reminder",
    "pauseFailed": "Ma zabet nwa22ef el reminder",
    "resumeFailed": "Ma zabet nkammel el reminder",
    "skipFailed": "Ma zabet nskip el reminder",
    "doneFailed": "Ma zabet n7ott tamem",
    "undoFailed": "Ma zabet ┘è╪▒╪¼╪╣ active hal reminder",
    "deleteFailed": "Ma zabet n7zef el reminder",
    "rescheduleTitle": "Erjaa jadwel?",
    "rescheduleMsg": "Hal reminder mit2akher. Baddak te3mol reschedule?",
    "reschedule15": "Ba3ed 15 d2i2a",
    "reschedule60": "Ba3ed se3a",
    "keepOverdue": "Khalliyo hek"
  }
}
